import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { saveAs } from 'file-saver';
import { Lightbox } from 'ngx-lightbox';
import { MenuItem } from 'primeng/api';
import { BaseService } from '../../services/base.service';

@Component({
  selector: 'ara-files-previewer',
  templateUrl: './files-previewer.component.html',
  styleUrls: ['./files-previewer.component.css']
})
export class FilesPreviewerComponent implements OnChanges {
  @Input()
  files: any = [];
  filesPreview: any = [];
  contextItems: MenuItem[] = [];
  currentFileUrl: string;
  row: HTMLElement;
  displayFile: boolean = false;
  Zoom: number = 1;
  PreviewUrl: string;
  FileName: string;
  constructor(private lightbox: Lightbox,
    private translate: TranslateService,
    private baseService: BaseService) {
    this.contextItems = [
      {
        label: 'Download',
        icon: 'fa-download',
        command: e => { saveAs(this.currentFileUrl); }
      }];
  }

  ngOnChanges() {
    if (this.files && this.files.length > 0) {
      let tempFiles: Images[] = [];
      this.files.forEach(file => {
        if (file && file.hasOwnProperty('FilePath')) {
          let image: Images = new Images();
          image.src = file.SourceUrl.replace(/&amp;/gi, "&");
          image.thumb = file.FilePath;
          image.caption = image.src.substr(image.src.lastIndexOf('/') + 1, image.src.length - image.src.lastIndexOf('/'))
          tempFiles.push(image);
        }
      });
      this.files = tempFiles;
      this.filesPreview = this.files.filter(file => {
        if (file && file.src && (file.src.toLocaleLowerCase().includes('.heif') || file.src.toLocaleLowerCase().includes('.heic') || file.src.toLocaleLowerCase().includes('.png') || file.src.toLocaleLowerCase().includes('.bmp') || file.src.toLocaleLowerCase().includes('.jpg') || file.src.toLocaleLowerCase().includes('.jpeg') || file.src.toLocaleLowerCase().includes('.svg'))) {
          return file;
        }
      });
      this.filesPreview = [...this.filesPreview];
    }
    this.baseService.translatorListener.subscribe((data) => {
      this.translate.use(data);
    });
  }
  open(fileURL): void {
    let fileIndex = 0;
    for (let index = 0; index < this.filesPreview.length; index++) {
      const element = this.filesPreview[index];
      if (element.thumb === fileURL) {
        fileIndex = index;
      }
    }
    // open lightbox
    this.lightbox.open(this.filesPreview, fileIndex);
  }

  close(): void {
    // close lightbox programmatically
    this.lightbox.close();
  }
  selectFile(fileUrl) {
    this.currentFileUrl = fileUrl;
  }
  downloadFile(url) {
    saveAs(url);
  }
  downloadPDFFile(url,fileName){
    saveAs(url,fileName);
  }

  showDialog(fileUrl,fileName) {
    this.PreviewUrl = fileUrl;
    this.FileName = fileName;
    this.displayFile = true;
}

zoomPrev(value){
  if (value == 1) {
    this.Zoom = this.Zoom + 0.25;
  }
  else if (value == 0) {
    this.Zoom = this.Zoom - 0.25;
  }
}
}
export class Images {
  src: string;
  caption: string;
  thumb: string;
}
